/* globals jQuery */
//https://swiperjs.com/
import Swiper, {Navigation, Pagination, EffectFade, Scrollbar, A11y,} from 'swiper';

Swiper.use([Navigation,Pagination,EffectFade,Scrollbar, A11y]);

(($) => {

    //MAIN HERO SLIDESHOW
    var mainSwiper = new Swiper('.slideshow', {
		effect: 'fade',
		loop: true,
		parallax: true,
		speed: 500,
		allowTouchMove: false,
        autoplay:{
            delay: 7000, //7 seconds per slide
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
    });

})(jQuery)